import { render, staticRenderFns } from "./device-list.vue?vue&type=template&id=6ddb54ae&scoped=true&"
import script from "./device-list.vue?vue&type=script&lang=js&"
export * from "./device-list.vue?vue&type=script&lang=js&"
import style0 from "./device-list.vue?vue&type=style&index=0&id=6ddb54ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddb54ae",
  null
  
)

export default component.exports